import { useEffect, useRef, type ReactNode } from "react";

interface ModalProps {
  open: boolean;
  title: string;
  description?: string;
  onClose(): void;
  children: ReactNode;
}

export function Modal({ open, title, description, onClose, children }: ModalProps) {
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;
    if (open && !dialog.open) dialog.showModal();
    if (!open && dialog.open) dialog.close();
  }, [open]);

  return (
    <dialog className="app-dialog" ref={dialogRef} onClose={onClose} onCancel={(event) => { event.preventDefault(); onClose(); }}>
      <div className="sheet-handle" />
      <button className="sheet-close" type="button" aria-label="Close" onClick={onClose}>×</button>
      <h2>{title}</h2>
      {description && <p>{description}</p>}
      {children}
    </dialog>
  );
}
